function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#listen_svg__filter0_b_3496_10321)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.17 50c13.807 0 25-11.193 25-25s-11.193-25-25-25-25 11.193-25 25 11.193 25 25 25zm2.99-26c0 1.66-1.33 3-2.99 3-1.66 0-3-1.34-3-3v-6c0-1.66 1.34-3 3-3s3 1.34 3 3l-.01 6zm-2.99 5.1c2.76 0 5.3-2.1 5.3-5.1h1.7c0 3.42-2.72 6.24-6 6.72V34h-2v-3.28c-3.28-.49-6-3.31-6-6.72h1.7c0 3 2.54 5.1 5.3 5.1z",
  fill: "#fff",
  fillOpacity: 0.5
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "listen_svg__filter0_b_3496_10321",
  x: -19.83,
  y: -20,
  width: 90,
  height: 90,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  "in": "BackgroundImage",
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_3496_10321"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_backgroundBlur_3496_10321",
  result: "shape"
})));

function SvgListen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 51 50",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgListen;